import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useDestinationDropdown = () => {
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const res = await customAxios.get('/CRM/GetCustomerLocations', {
          headers: authHeader(),
        });

        if (res.status === 200 && Array.isArray(res.data)) {
          // Extract destination names only
          const destinationNames = res.data.map(item => item.destinationName); // remove any null/undefined
          setDestinations(destinationNames);
        } else {
          setDestinations([]);
        }
      } catch (err) {
        console.error('Failed to fetch destinations:', err);
        setDestinations([]);
      }
    };

    fetchDestinations();
  }, []);

  return destinations;
};

export default useDestinationDropdown;
